import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Plane } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function NotFound() {
  return (
    <section className="max-w-3xl mx-auto px-4 md:px-6 py-24 text-center">
      <div className="w-16 h-16 rounded-2xl bg-teal-50 text-teal-700 flex items-center justify-center mx-auto">
        <Plane className="w-8 h-8" />
      </div>
      <div className="font-display font-extrabold text-6xl text-slate-900 mt-6">404</div>
      <h1 className="font-display font-extrabold text-2xl md:text-3xl text-slate-900 mt-2">This page took a different flight</h1>
      <p className="text-slate-600 mt-3">The page you’re looking for doesn’t exist or has been moved. Let’s get you back on track.</p>
      <div className="mt-8 flex items-center justify-center gap-3">
        <Link to="/"><Button className="bg-teal-700 hover:bg-teal-800 text-white gap-1"><Home className="w-4 h-4" /> Back to home</Button></Link>
        <Link to="/flights"><Button variant="outline" className="gap-1"><ArrowLeft className="w-4 h-4" /> Search flights</Button></Link>
      </div>
    </section>
  );
}
